module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"addSkill":"Aggiungi Tag","userSkill":"Tag dell\u0027utente","selectSkill":"Scegli tag"}}')
  delete Component.options._Ctor
}
